<template>
  <div class="box text-center">
    <!-- /.box-header -->
    <div class="box-body form">
      <br />
      <div><h3>{{ title }}</h3></div>
      <!--<div>-->
      <!--<div class="input-group">-->
      <!--<span class="input-group-addon">店家名稱 (ID)</span>-->
      <!--<div class="form-control form-info">-->
      <!--{{storeInfo.name}} ({{storeInfo.id}})-->
      <!--</div>-->
      <!--</div>-->
      <!--</div>-->
    </div>
    <div class="ad-form">
    <div class="row">
      <div class="col-md-6 ad-form-left">
        <div>
          <div class="input-group">
        <span class="input-group-addon">
          <span class="text-red">＊ </span>名稱
        </span>
            <input class="form-control" placeholder="" type="text" v-model="adInfo.name" maxlength="45">
          </div>
        </div>
        <br>
        <div>
          <div class="input-group">
          <span class="input-group-addon">
            <span class="text-red">＊ </span>啟用
          </span>
            <div class="form-group">
              <select class="form-control" v-model="adInfo.is_active">
                <option value="1">啟用</option>
                <option value="0">停用</option>
              </select>
            </div>
          </div>
        </div>
        <br>
        <!-- 41:蓋版廣告不設定品牌連結 -->
        <div v-if="bannerType !== 41">
          <div class="input-group">
          <span class="input-group-addon">
            連結
          </span>
            <input class="form-control" placeholder="" type="text" v-model="adInfo.url" maxlength="100">
          </div>
        </div>
        <!-- 41:蓋版廣告不設定品牌連結 -->
      </div>
      <div class="col-md-6">
        <div>
          <div class="input-group cr-schedule cr-ad">
          <span class="input-group-addon">
            <span class="text-red">＊ </span>開始時間
          </span>
            <date-time-picker :date="menuTime.start" :option="timeoption" :limit="startLimit"></date-time-picker>
            <!--<input class="form-control w-200" placeholder="" type="text" v-model="menuTime.start">-->
          </div>
          <br />
        </div>
        <div>
          <div class="input-group cr-schedule cr-ad">
          <span class="input-group-addon">
            <span class="text-red">＊ </span>結束時間
          </span>
            <date-time-picker  :date="menuTime.end" :option="timeoption" :limit="endLimit"></date-time-picker>
            <!--<input class="form-control w-200" placeholder="" type="text" v-model="menuTime.start">-->
          </div>
        </div>
        <br>
        <div>
          <!-- 41:蓋版廣告不設定永久顯示 -->
          <div
            v-if="bannerType !== 41"
            class="input-group"
          >
            <span class="input-group-addon">
              <span class="text-red">＊ </span>永久顯示
            </span>
            <div class="form-group select-right">
              <select class="form-control" v-model="adInfo.foreverShow">
                <option value="1">是</option>
                <option value="0">否</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 廣告地區 - Start -->
    <div v-if="bannerType !== 41" class="row">
      <br>
      <div class="col-12 flex">
        <div class="cell">
          <span class="text-red">＊ </span>廣告地區
          <span class="nd-tooltip">
            <ion-icon name="help-circle"></ion-icon>
            <span class="nd-tooltip-text center">
              *依據消費者位置指定廣告要出現的縣市(目前限台灣地區)。<br>
              *若無法判斷位置或在非台灣地區，則預設都顯示。
            </span>
          </span>
        </div>
        <div class="radio inline-block cell-right">
          <label>
            <input v-model="adInfo.is_limit_location" type="radio" name="is_limit_location" :value="0"/>
            不限制
          </label>
          <label class="ml-5">
            <input v-model="adInfo.is_limit_location" type="radio" name="is_limit_location" :value="1"/>
            指定區域
          </label>
        </div>
      </div>
      <div v-if="adInfo.is_limit_location">
        <br>
        <div class="input-group">
          <span class="input-group-addon">
            <span class="text-red">＊ </span>指定區域
          </span>
          <multiselect
            class="min-w-150"
            v-model="adInfo.city_code_list"
            :options="getCityOption"
            :searchable="false"
            :allow-empty="true"
            :close-on-select="false"
            :show-labels="false"
            placeholder=""
            :multiple="true"
            label="name"
            track-by="code"
          />
        </div>
      </div>
    </div>
    <!-- 廣告地區 - End -->

    <div class="upload-image">
    <div class="input-group">
      <span class="input-group-addon">
        <span class="text-red">＊ </span>圖片
      </span>
      <div class="input-group-addon w-100-p text-center p-all-0 bg-white" style="border-right: none;">
        <span class="inline-block h-auto">
          <img
            v-if="!adInfo.image_web_file"
            class="img-responsive h-auto"
            :src="defaultImage"
          />
          <img
            v-if="adInfo.image_web_file"
            class="h-auto img-responsive"
            :src="adInfo.image_web_file"
            data-toggle="modal"
          >
        </span>
      </div>
      <div class="form-control h-100">
        <div>
          <label class="btn-upload btn btn-default m-t-25" style="margin-top: 8px;" for="brand-img-load">
            選擇圖片
          </label>
          <input class="form-control" type="file" style="display: none;" @change="onFileChange" id="brand-img-load">
        </div>
      </div>
    </div>
    <div
      class="text-right text-15 text-red"
      v-text="tipsImage"
    />
    <br />
    </div>
    <div class="row store-bannder">
      <div><h3>套用門市設定</h3></div>
      <div class="col-12 flex">
        <div class="cell"><span class="text-red">＊ </span>套用門市</div>
        <div class="radio inline-block cell-right">
          <label>
            <input v-model="isCopyStore" type="radio" name="setStore" :value="true"/>
            是
          </label>
          <label class="ml-5">
            <input v-model="isCopyStore" type="radio" name="setStore" :value="false"/>
            否
          </label>
        </div>
      </div>
      <div v-if="isCopyStore" class=" col-12 text-left m-t-25">
        <h5>參與店家</h5>
        <div>
          <div v-for="(storeClass, index) in storeClassList" class="m-r-5 m-b-10 inline-block">
            <button class="btn btn-default" :class="{'active': curId === storeClass.id}" @click="clickOption(storeClass)">
              {{storeClass.name}}
            </button>
          </div>
        </div>
        <!-- 參與店家 -->
        <muti-select-two :setting="addStoresSetting" :reNew="reNew" :reSet="reSet"></muti-select-two>
      </div>
      <br>
    </div>
    <div class="row">
      <div class="col-12 flex">
        <div class="cell"><span class="text-red">＊ </span>街口平台
        <span data-toggle="tooltip" class="tip-icon" data-placement="bottom" title="與街口支付APP合作之你訂獨家功能，有興趣可洽業務窗口。若未簽約合作請勿啟用。">
                    <i class="fa fa-question-circle" aria-hidden="true"></i>
                  </span>
        </div>
        <div class="radio inline-block cell-right">
          <label :style="adInfo.is_active === '0'? 'color: #C2C2C2': ''" >
            <input v-model="isJkosOpen" :disabled = "adInfo.is_active === '0'" type="radio" name="setJkos" :value="true"/>
            啟用
          </label>
          <label class="ml-5">
            <input v-model="isJkosOpen" type="radio" name="setJkos" :value="false"/>
            停用
          </label>
        </div>
      </div>
    </div>
    </div>
    <br>
    <div class="box-footer text-center">
      <button class="btn btn-default" @click="$router.go(-1)">
        取消
      </button>
      <button class="btn btn-success" v-if="!info" @click="checkBeforeSend('cr')">
        新增
      </button>
      <button class="btn btn-success" v-if="info" @click="checkBeforeSend('up')">
        修改
      </button>
    </div>
    <br />
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import $ from 'jquery'
import ImgUploadTemp from './ImgUploadTemp.vue'
import datetimePicker from 'vue-datepicker/vue-datepicker-es6.vue'
// import moment from 'moment'
import VueTimepicker from 'vue2-timepicker'
// import 'src/static/js/plugins/notify/notify.min.js'
export default {
  props: {
    'info': {
      type: Object
    }
  },
  data () {
    return {
      bannerType: Number(this.$route.query.tab) || 12,
      newPhoto: this.$route.query.new,
      img: {
        width: 0,
        height: 0
      },
      isCopyStore: true,
      isJkosOpen: false,
      addStoresSetting: {
        class: 'add-store',
        options: [],
        choose: []
      },
      adInfo: {
        name: '',
        url: '',
        start_time: '',
        end_time: '',
        image_web_file: '',
        sort: 1,
        is_active: 1,
        is_limit_location: 0,
        city_code_list: [],
        foreverShow: 0
      },
      storeInfo: {},
      storeClassList: [],
      curId: 0,
      reNew: 0,
      reSet: 0,
      // time
      menuTime: {
        start: {
          time: ''
        },
        end: {
          time: ''
        }
      },
      startTime: {
        time: ''
      },
      endtime: {
        time: ''
      },
      timeoption: {
        type: 'min',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD HH:mm:ss',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'max-width': '280px',
          'color': '#555'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      },
      startLimit: [
        {
          type: 'fromto',
          from: moment().add(-1, 'day').format('YYYY-MM-DD HH:mm:ss')
        }
      ],
      endLimit: [
        {
          type: 'fromto',
          from: moment().format('YYYY-MM-DD HH:mm:ss')
        }
      ]
    }
  },
  methods: {
    ...mapActions(['setCityList']),
    init () {
      this.getStoreBrief()
    },
    getStoreBrief () {
      this.storeBrief = []
      this.addStoresSetting.options = []
      var self = this
      var url = '/brand/' + this.$route.params.brand_id + '/storeListBrief?&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.getStoreClassList()
          var sList = response.data.list
          for (let i = 0; i < sList.length; i++) {
            let obj = {label: sList[i].name, value: sList[i].store_id}
            if (parseInt(sList[i].store_id, 10) !== parseInt(self.$route.params.store_id, 10)) {
              self.storeBrief.push(obj)
              self.addStoresSetting.options.push(obj)
            }
          }
          self.reNew++
          if (self.$route.name === 'upBrandAd') self.getAdInfo()
        }
      })
    },
    getStoreClassList () {
      var self = this
      var url = 'brand/' + this.$route.params.brand_id + '/storeClassList'
      if (this.getRoleType === 10) url = 'store/' + this.$route.params.brand_id + '/storeClassList'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list
          self.storeClassList = sList
        }
      })
    },
    clickOption (option) {
      var self = this
      this.addStoresSetting.options = []
      self.curId = option.id
      if (self.curId) {
        self.$nextTick(function () {
          self.reSet++
          self.addStoresSetting.options = self.storeBrief
          self.getCurStoreClass()
        })
      }
    },
    getCurStoreClass () {
      this.addStoresSetting.choose = []
      var self = this
      var url = 'brand/' + this.$route.params.brand_id + '/storeClass/' + this.curId
      if (this.getRoleType === 10) url = 'store/' + this.$route.params.brand_id + '/storeClass/' + this.curId
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var classInfo = response.data.class
          classInfo.store_list.forEach(function (s) {
            self.addStoresSetting.choose.push(s.id)
          })
        }
      })
    },
    veritySort () {
      var e = $(this.$refs.sort)
      this.adInfo.sort = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/))
      }
    },
    getAdInfo () {
      var self = this
      var url = '/brand/' + this.$route.params.brand_id + '/banner/' + this.$route.params.ad_id
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          const adInfo = response.data.info
          self.adInfo = {
            name: adInfo.name,
            url: adInfo.url.trim(),
            start_time: adInfo.start_time,
            end_time: adInfo.end_time,
            is_active: adInfo.is_active,
            image_web_file: adInfo.image_web,
            sort: adInfo.sort,
            foreverShow: 0,
            is_limit_location: adInfo.is_limit_location || 0,
            city_code_list: adInfo.city_code_list || []
          }
          self.isCopyStore = !!adInfo.store_list.length
          adInfo.store_list.forEach(item => {
            self.addStoresSetting.choose.push(item)
          })
          self.menuTime.start.time = self.adInfo.start_time
          self.menuTime.end.time = self.adInfo.end_time
          if (adInfo.banner_type === 12 || adInfo.banner_type === 41) {
            self.newPhoto = true
          }
          if (adInfo.dedicated_visible_setting.length) {
            self.isJkosOpen = adInfo.dedicated_visible_setting.includes(1)
          }
        }
      })
    },
    onFileChange (e) {
      this.imgLogoSelect = ''
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      let imgName = files[0].name.split('.')
      let imgSize = Math.round(files[0].size / 1000)
      if (imgName.length < 2 || !imgName[imgName.length - 1].match(/(jpg|jpeg|png)$/i)) {
        this.$notify({
          title: '提醒',
          text: '圖片格式錯誤！',
          duration: 3000,
          type: 'danger',
          width: 400
        })
        // $('#file-upload').replaceWith($('#file-upload').val(''))
      } else if (imgSize > 1024) {
        this.$notify({
          title: '提醒',
          text: '圖片檔案為' + imgSize + 'KB，請上傳小於1024KB之圖片',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else {
        this.createImage(files[0])
      }
    },
    createImage (file) {
      var reader = new FileReader()
      var self = this
      reader.onload = (e) => {
        var img = new Image()
        img.src = e.target.result
        self.adInfo.image_web_file = img.src
        img.onload = () => {
          self.img.width = img.width
          self.img.height = img.height
          self.checkImgSize()
        }
      }
      reader.readAsDataURL(file)
    },
    checkImgSize (type) {
      var self = this
      if ((this.img.width !== 1280 || this.img.height !== 300) && this.img.width !== 0 && this.img.height !== 0 && !this.newPhoto && this.bannerType === 11) {
        this.$notify({
          title: '提醒',
          text: '圖片尺寸為' + self.img.width + 'x' + self.img.height + '，請上傳1280x300之圖片！',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else if ((this.img.width !== 1000 || this.img.height !== 460) && this.img.width !== 0 && this.img.height !== 0 && this.newPhoto && this.bannerType === 12) {
        this.$notify({
          title: '提醒',
          text: '圖片尺寸為' + self.img.width + 'x' + self.img.height + '，請上傳1000x460之圖片！',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else if ((this.img.width !== 480 || this.img.height !== 530) && this.img.width !== 0 && this.img.height !== 0 && this.newPhoto && this.bannerType === 41) {
        this.$notify({
          title: '提醒',
          text: '圖片尺寸為' + self.img.width + 'x' + self.img.height + '，請上傳480x530之圖片！',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      }
    },
    checkBeforeSend (type) {
      let all = this.getInput
      let msg = ''
      if (!all.name) {
        msg = '請輸入廣告名稱'
      } else if (!this.menuTime.start.time) {
        msg = '請輸入開始時間'
      } else if (!this.menuTime.end.time) {
        msg = '請輸入結束時間'
      } else if (!$('#brand-img-load')[0].files[0] && type === 'cr') {
        msg = '請上傳一張圖片'
      } else if (this.isCopyStore && !this.addStoresSetting.choose.length) {
        msg = '請選擇套用門市'
      }
      this.getToast(msg, type)
    },
    getToast (msg, type) {
      if (msg) {
        this.$notify({
          title: '提醒',
          text: msg,
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else {
        if (type === 'cr') this.createdAd()
        else if (type === 'up') this.updatedAd()
      }
    },
    getStoreInfo () {
      var self = this
      var url = '/store/' + this.$route.params.store_id + '/info'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.storeInfo = response.data.info
        }
      })
    },
    getBrandImgList () {
      var self = this
      var url = '/brand/' + this.$route.params.brand_id + '/storesImage?image_type=1'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var logoList = response.data.list
          for (var i = 0; i < logoList.length; i++) {
            var option = {name: logoList[i].image_name, value: logoList[i].image_url}
            self.imgLogoOption.push(option)
          }
        }
      })
      var url2 = '/brand/' + this.$route.params.brand_id + '/storesImage?image_type=3'
      this.getDataH('get', url2, null, function (response) {
        if (response.data.status === 200) {
          var bgList = response.data.list
          for (var j = 0; j < bgList.length; j++) {
            var option2 = {name: bgList[j].image_name, value: bgList[j].image_url}
            self.imgBgOption.push(option2)
          }
        }
      })
    },
    createdAd () {
      var self = this
      var data = new FormData()
      var info = this.getInput
      var name = info.name
      var picUrl = info.url
      var startTime = this.menuTime.start.time
      var endTime = this.menuTime.end.time
      var sort = parseInt(info.sort, 10)
      if (!picUrl) picUrl = ' '
      if (!this.newPhoto) data.append('banner_type', 11)
      else data.append('banner_type', this.bannerType)
      data.append('name', name)
      data.append('url', picUrl)
      data.append('start_time', startTime)
      data.append('end_time', endTime)
      data.append('sort', sort)
      data.append('is_active', this.adInfo.is_active)
      // icon 圖片
      data.append('image_web_file', $('#brand-img-load')[0].files[0])
      // 限制地區
      data.append('is_limit_location', this.adInfo.is_limit_location)
      if (this.adInfo.is_limit_location && this.adInfo.city_code_list.length) {
        let city = this.adInfo.city_code_list.map(item => { return item.code })
        if (city.length) data.append('city_code_list', city.join(','))
      }
      // 套用門市
      if (this.isCopyStore) {
        this.addStoresSetting.choose.forEach(id => {
          data.append('store_list[]', id)
        })
      }
      // 街口平台
      if (this.isJkosOpen) {
        data.append('dedicated_visible_setting[]', 1)
      }
      var url = '/brand/' + this.$route.params.brand_id + '/banner/newBanner'
      if (data) {
        this.getDataH('post', url, data, function (response) {
          if (response.data.status === 200) {
            self.$notify({
              title: response.data.message,
              text: response.data.description,
              duration: 3000,
              type: 'success',
              width: 400
            })
            // self.$router.replace({path: '/brandAdTable/' + self.$route.params.brand_id})
            self.$router.go(-1)
          }
        }, function (err) {
          console.error(err)
          self.handleError()
        })
      }
    },
    updatedAd () {
      var self = this
      var data = new FormData()
      var info = this.getInput
      var name = info.name
      var picUrl = info.url
      var startTime = this.menuTime.start.time
      var endTime = this.menuTime.end.time
      var sort = parseInt(info.sort, 10)
      if (!picUrl) picUrl = ' '
      if (!this.newPhoto) data.append('banner_type', 11)
      else data.append('banner_type', this.bannerType)
      data.append('name', name)
      data.append('url', picUrl)
      data.append('start_time', startTime)
      data.append('end_time', endTime)
      data.append('sort', sort)
      data.append('is_active', this.adInfo.is_active)
      // 限制地區
      data.append('is_limit_location', this.adInfo.is_limit_location)
      if (this.adInfo.is_limit_location && this.adInfo.city_code_list.length) {
        let city = this.adInfo.city_code_list.map(item => { return item.code })
        if (city.length) data.append('city_code_list', city.join(','))
      }
      // icon 圖片
      if ($('#brand-img-load')[0].files[0]) {
        data.append('image_web_file', $('#brand-img-load')[0].files[0])
      }
      // 套用門市
      if (this.isCopyStore) {
        this.addStoresSetting.choose.forEach(id => {
          data.append('store_list[]', id)
        })
      }
      // 街口平台
      if (this.isJkosOpen) {
        data.append('dedicated_visible_setting[]', 1)
      }
      var url = '/brand/' + this.$route.params.brand_id + '/banner/' + this.$route.params.ad_id
      if (data) {
        this.getDataH('post', url, data, function (response) {
          if (response.data.status === 200) {
            self.$notify({
              title: response.data.message,
              text: response.data.description,
              duration: 3000,
              type: 'success',
              width: 400
            })
            // self.$router.replace({path: '/brandAdTable/' + self.$route.params.brand_id})
            self.$router.go(-1)
          }
        }, function (err) {
          self.handleError(err)
        })
      }
    },
    handleError (err) {
      let title = ''
      let text = ''
      if (err.response.data.status === 90055) {
        title = '錯誤訊息'
        text = '目前已有一進行中的蓋版廣告，若需更換廣告，請將進行中的廣告停用，再將欲上架的廣告啟用。'
      } else {
        title = err.response.data.message
        text = err.response.data.description
      }
      this.$notify({
        title: title,
        text: text,
        duration: 3000,
        type: 'danger',
        width: 400
      })
    }
  },
  created () {
    if (!this.getCityOption.length) {
      // 取得縣市列表
      this.setCityList()
    }
    this.init()
  },
  components: {
    'img-upload': ImgUploadTemp,
    'date-time-picker': datetimePicker,
    VueTimepicker
  },
  computed: {
    ...mapGetters(['getCityOption']),
    checkInput () {
      return this.$parent.checkInput
    },
    getDataH () {
      return this.$parent.getDataH
    },
    getData () {
      return this.$parent.getData
    },
    getInput () {
      var aInfo = this.adInfo
      for (let key in aInfo) {
        if (!aInfo[key] && typeof aInfo[key] === 'object') aInfo[key] = ' '
      }
      return {
        name: this.checkInput(aInfo.name.toString()),
        url: this.checkInput(aInfo.url.toString()),
        sort: this.checkInput(aInfo.sort.toString())
      }
    },
    defaultImage () {
      let url = ''
      switch (this.bannerType) {
        case 12:
        case 41:
          url = ''
          break
        default:
          break
      }
      return url
    },
    tipsImage () {
      let size = ''
      let kb = '512'
      switch (this.bannerType) {
        case 12:
          size = '1000x460'
          break
        case 31:
          size = '720x240'
          break
        case 41:
          size = '480x530'
          kb = '256'
          break
        default:
          break
      }
      return `圖片大小為 ${size} ${kb}KB 內`
    },
    title () {
      let title = ''
      switch (this.bannerType) {
        case 12:
          title = '橫幅'
          break
        case 41:
          title = '蓋版'
          break
        default:
          break
      }
      return `${title}廣告資訊`
    }
  },
  watch: {
    'menuTime.start.time' () {
      this.endLimit = [
        {
          type: 'fromto',
          from: this.menuTime.start.time
        }
      ]
      // this.setMenuStartTime(this.menuTime.start.time)
    },
    'menuTime.end.time' () {
      this.startLimit = [
        {
          type: 'fromto',
          from: moment().add(-1, 'day').format('YYYY-MM-DD HH:mm:ss'),
          to: this.menuTime.end.time
        }
      ]
      // this.setMenuEndTime(this.menuTime.end.time)
    },
    'adInfo.foreverShow' (val) {
      if (val) {
        this.menuTime.end.time = '2099-12-31 00:00:00'
      }
    },
    'adInfo.is_active' () {
      if (this.adInfo.is_active === '0') {
        this.isJkosOpen = false
      }
    }
  }
}
</script>

<style scoped>
.cr-ad.input-group.cr-schedule .cov-vue-date .cov-datepicker {
  width: calc(60vw - 165px)
}
.ad-form {
  width: 800px;
  margin: 0px auto;
}
.store-bannder {
  width: 800px;
  margin: 0px auto;
}
.ad-form-left {
  padding-right: 20px;
}
.cov-vue-date {
  text-align: start;
}
.upload-image {
  margin-top: 20px;
}
.cell {
  width: fit-content;
  background-color: #222d32;
  color:#FFF;
  text-align: left;
  padding: 6px 12px;
  font-weight: bold;
}
.flex {
  display: flex;
}
.cell-right {
  padding: 6px 12px;
}
.ml-5 {
  margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// BrandAdFormTemp.vue?8677f452